
export const industries = [
  {label:"TECHNOLOGY",value:"TECHNOLOGY"},
  {label:"FINANCE",value:"FINANCE"},
  {label:"HEALTHCARE",value:"HEALTHCARE"},
  {label:"MANUFACTURING",value:"MANUFACTURING"},
  {label:"RETAIL",value:"RETAIL"},
  {label:"EDUCATION",value:"EDUCATION"},
  {label:"REAL ESTATE",value:"REAL_ESTATE"},
  {label:"TELECOMMUNICATIONS",value:"TELECOMMUNICATIONS"},
  {label:"CONSTRUCTION",value:"CONSTRUCTION"},
  {label:"TRANSPORTATION AND LOGISTICS",value:"TRANSPORTATION_AND_LOGISTICS"},
  {label:"HOSPITALITY",value:"HOSPITALITY"},
  {label:"MEDIA AND ENTERTAINMENT",value:"MEDIA_AND_ENTERTAINMENT"},
  {label:"GOVERNMENT",value:"GOVERNMENT"},
  {label:"NON PROFIT",value:"NON_PROFIT"},
  {label:"AGRICULTURE",value:"AGRICULTURE"},
  {label:"LEGAL SERVICES",value:"LEGAL_SERVICES"},
  {label:"AUTOMOTIVE",value:"AUTOMOTIVE"},
  {label:"AEROSPACE AND DEFENSE",value:"AEROSPACE_AND_DEFENSE"},
  {label:"CHEMICALS",value:"CHEMICALS"},
  {label:"MINING AND METALS",value:"MINING_AND_METALS"},
  {label:"FOOD AND BEVERAGE",value:"FOOD_AND_BEVERAGE"},
  {label:"SPORTS AND RECREATION",value:"SPORTS_AND_RECREATION"},
]
